import v42Schema from "../client/schemaVersions/v42.js";
import v43Schema from "../client/schemaVersions/v43.js";
import { createMigration } from "@verdant-web/store";
export default createMigration(v42Schema, v43Schema, async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
});
//# sourceMappingURL=v43.js.map